module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tableHeaderCheckinsPerTeamPoi":"Nom du POI","tableHeaderCheckinsPerTeamCompletion":"Progression","tableHeaderCheckinsPerTeamTeamsNumber":"Nbre d\u0027équipes / Total"},"en":{"tableHeaderCheckinsPerTeamPoi":"POI name","tableHeaderCheckinsPerTeamCompletion":"Progression","tableHeaderCheckinsPerTeamTeamsNumber":"Number of Teams / Total"}}')
  delete Component.options._Ctor
}
